import React, { useContext, useState, useCallback, useEffect } from 'react'
import styled, { ThemeContext } from 'styled-components'
import { RouteComponentProps } from 'react-router-dom'

// components
import Loading from '../../components/Loader/Loading'
import Row from '../../components/Row'
import Artworks from '../../components/nftInfo/Artworks'
import NoArtworks from '../../components/nftInfo/NoArtworks'
import Paginator from '../../components/Paginator'
import BiddingList from '../../components/nftInfo/BiddingList'
import TradingList from '../../components/nftInfo/TradingList'
import InfoAddress from '../../components/nftInfo/InfoAddress'
import Introduction from '../../components/nftInfo/Introduction'
import InfoButton from '../../components/nftInfo/InfoButton'
import InfoImgCard from '../../components/nftInfo/InfoImgCard'

// utils
import { getSushiAddress } from '../../sushi/utils'
import { getBalanceNumber } from '../../utils/bakery/formatBalance'
import { SortOptions, TabOptions, ArtworkProps, AuctionBake, defaultArtworks } from '../../constants/artwork'
import { MARKETTYPE, SUPPORTTYPE } from '../../constants/bakery/nft'
import { deepCopy } from '../../utils/func'

// hooks
import { useActiveWeb3React } from '../../hooks'
import useYam from '../../hooks/bakery/useYam'
import useTokenBalance from '../../hooks/bakery/useTokenBalance'
import useInterval from '../../hooks/useInterval'

import { useReviewAddress } from '../../hooks/launchArtworks/useContract'

import SortPets from '../Pet/components/SortPets'
import { getArtworks, getArtworksV2 } from '../../service/nft'
import { useMarketLevel } from '../../state/market/hooks'


const RowColumn = styled(Row)`
  display: flex;
  flex-wrap: wrap;
  width: 1204px;
  margin: auto;
  box-sizing: border-box;
  justify-content: flex-start;

  ${({ theme }) => theme.mediaWidth.upToBigerLarge`
    width: 904px;
  `}

  ${({ theme }) => theme.mediaWidth.upToLarge`
    width: 628px;
  `}

  ${({ theme }) => theme.mediaWidth.upToMedium`
    width: 605px;
  `}

  ${({ theme }) => theme.mediaWidth.upToSmall`
    width: 100%;
    padding: 0px 20px;
    justify-content: center;
  `}
`

const TabRow = styled(Row)<{margin?: string, width?: string}>`
  margin: ${({margin}) => (margin ? margin : 'auto')};
  width: ${({width}) => (width ? width : 'auto')};
  justify-content: space-between;
  ${({ theme }) => theme.mediaWidth.upToSmall`
    margin-bottom: 15px;
    flex-direction: column;
    align-items: center;
    width: auto;
  `}
`
const TextLabel = styled.div<{width?: string, height?: number, color?: string; family?: string; size?: number; top?: string; weight?: string}>`
  width: ${({width}) => (width ? width : 'auto')};
  line-height: ${({height}) => (height ? height : 28)}px;  
  color: ${({color}) => (color)};
  font-family: ${({family}) => (family ? family : 'Baloo Da')}!important;
  font-size: ${({size}) => (size ? size : 28)}px;
  margin: ${({top}) => (top ? top : 0)};
  font-weight: ${({weight}) => (weight ? weight : 'normal')};
`
const RowColumnInfo = styled(Row)`
  padding: 48px 0;
  padding-bottom: 72px;
  align-items: flex-start;
  ${({ theme }) => theme.mediaWidth.upToBigerLarge`
    flex-direction: column;
    align-items: center;
  `}
`
const BidTrad = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
`
const InfoRight = styled(RowColumn)`
  align-items: flex-start;
  ${({ theme }) => theme.mediaWidth.upToMedium`
    align-items: center;
  `}
`
const InfoDiv = styled.div`
  width: 100%;
  padding-bottom: 48px;
  min-height: 350px;
  border-bottom: 1px dashed rgba(214, 164, 133, 0.5);
  ${({ theme }) => theme.mediaWidth.upToMedium`
    height: auto;
    min-height: auto;
  `}
`
const ArtworksList = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 1204px;
  margin: auto;
  box-sizing: border-box;
  justify-content: flex-start;

  ${({ theme }) => theme.mediaWidth.upToBigerLarge`
    width: 904px;
  `}

  ${({ theme }) => theme.mediaWidth.upToLarge`
    width: 628px;
  `}

  ${({ theme }) => theme.mediaWidth.upToMedium`
    width: 605px;
  `}

  ${({ theme }) => theme.mediaWidth.upToSmall`
    width: 100%;
    padding: 0px 20px;
    justify-content: center;
  `}
`

export default function ArtworkInfo ({
  match: {
    params: { tokenId, isMyArtwork, price, status }
  },
  history
}: RouteComponentProps<{ tokenId: string, isMyArtwork: string, price: string, status: string }>) {
  const NFTTYPE = 'MEME'
  const level = useMarketLevel()
  const theme = useContext(ThemeContext)
  const { account, chainId } = useActiveWeb3React()
  const [loadingFlag, setLoadingFlag] = useState(false)
  const [updateNum, setUpdateNum] = useState(1)
  const [artwork, setArtwork] = useState({...deepCopy(defaultArtworks), tokenId: tokenId, price: price, nftType: 5})

  const reviewAddress: any = useReviewAddress()
  const [canReview, setCanReview] = useState((account && reviewAddress ? reviewAddress.includes(account) : false))
  useEffect(() => {
    if (account && reviewAddress) {
      setCanReview(reviewAddress.includes(account))
    }
  }, [account, chainId, reviewAddress])

  const fetchArtworkInfo = async (tokenId: string, loading?: boolean) => {
    if (loading) {
      setLoadingFlag(true)
    }
    let params = {
      nftType: 5,
      ids: `5-${tokenId}`
    }
    fetchAsksSort(params, true)
  }

  // 根据tokenId获取详情
  useEffect(() => {
    fetchArtworkInfo(tokenId, true)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tokenId, chainId])

  // 获取列表
  const [curSelect, setCurSelect] = useState(SortOptions[5])
  const [curTab, setCurTab] = useState(TabOptions[0])
  const emptyArtworks: any[] = []
  const [artworks, setArtworks] = useState(emptyArtworks)
  
  const [page, setPage] = useState(1)
  useEffect(() => {
    setPage(1)
  }, [account, chainId, level])
  const LIMIT = 4

  const fetchAsks = async (page: number, loading?: boolean) => {
    if (loading) {
      setLoadingFlag(true)
    }
    let params = {
      nftType: 5,
      fileType: +curTab.sortName,
      offset: (page - 1) * LIMIT,
      limit: LIMIT + 1,
      sortName: curSelect.sortName,
      sortBy: curSelect.sortBy,
      onSale: +status === 1 ? 1 : undefined,
      status: canReview ? status : 1
    }
    fetchAsksSort(params)
  }
  
  // count
  const [pageCount, setPageCount] = useState(0)
  const fetchAsksSort = async (params: any, isInfo?: boolean) => {
    if (+params.fileType === 0) {
      (params.fileType as (string | number)) = ''
    }
    if (level === 'v1') {
      getArtworks(chainId as number, params, (err: any, data: any) => {
        if (err) return
        if (data.code !== 0) return
        const dataAry = data.data.list || []
        const artworks = dataAry.map((d: ArtworkProps) => {
          return {
            ...d,
            tokenId: d.nftId,
            maxBidPrice: (d.maxBidPrice && !Number(d.maxBidPrice)) && (d.auctionPrice && Number(d.auctionPrice)) ? d.auctionPrice.toString() : d.maxBidPrice,
            ...((d.price && Number(d.price)) ? {price: d.price.toString()} : {price: ''}),
            ...((d.auctionPrice && Number(d.auctionPrice)) && (d.price && Number(d.price) && +d.price === AuctionBake) ? {auctionPrice: d.auctionPrice.toString()} : {auctionPrice: ''})
          }
        })
        if (isInfo) {
          if (artworks.length) {
            setArtwork(artworks[0])
          } else {
            setArtwork({...deepCopy(defaultArtworks), tokenId: tokenId, price: price, nftType: 5})
          }
        } else {
          setPageCount(Math.ceil(data.data.count / LIMIT))
          setArtworks(artworks)
        }
        setLoadingFlag(false)
      })
    } else {
      getArtworksV2(chainId as number, params, (err: any, data: any) => {
        if (err) return
        if (data.code !== 0) return
        const dataAry = data.data.list || []
        const artworks = dataAry.map((d: ArtworkProps) => {
          return {
            ...d,
            tokenId: d.nftId,
            maxBidPrice: (d.maxBidPrice && !Number(d.maxBidPrice)) && (d.auctionPrice && Number(d.auctionPrice)) ? d.auctionPrice.toString() : d.maxBidPrice,
            ...((d.price && Number(d.price)) ? {price: d.price.toString()} : {price: ''}),
            ...((d.auctionPrice && Number(d.auctionPrice)) && (d.price && Number(d.price) && +d.price === AuctionBake) ? {auctionPrice: d.auctionPrice.toString()} : {auctionPrice: ''})
          }
        })
        if (isInfo) {
          if (artworks.length) {
            setArtwork(artworks[0])
          } else {
            setArtwork({...deepCopy(defaultArtworks), tokenId: tokenId, price: price, nftType: 5})
          }
        } else {
          setPageCount(Math.ceil(data.data.count / LIMIT))
          setArtworks(artworks)
        }
        setLoadingFlag(false)
      })
    }
  }

  const updateData = useCallback((d) => {
    setCurSelect(d)
    setPage(1)
  }, [])

  const upTab = useCallback((d) => {
    setCurTab(d)
    setPage(1)
  }, [])

  useEffect(() => {
    fetchAsks(page, true)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [canReview, page, curSelect, chainId, curTab, level])

  useInterval(() => {
    fetchArtworkInfo(tokenId)
    fetchAsks(page)
  }, account ? 10000 : null)

  const pageHandle = useCallback((value) => {
    setPage(value)
  }, [])

  // bake balance
  const [bakeBalance, setBakeBalance] = useState(0)
  const yam = useYam()
  const bakeryBalance = useTokenBalance(getSushiAddress(yam))
  useEffect(() => {
    const balance = getBalanceNumber(bakeryBalance)
    setBakeBalance(balance)
  }, [yam, bakeryBalance])
 
  return (
    <>
      <Loading open={loadingFlag} />
      <RowColumn>
        <RowColumnInfo>
          <InfoImgCard
            history={history}
            artwork={artwork}
            type={MARKETTYPE.MEME}
            bakeBalance={bakeBalance}
            status={+status}
            canReview={canReview}
            isMyArtwork={+isMyArtwork === 1 ? true : false}
            tokenName={SUPPORTTYPE.BAKE}></InfoImgCard>
          <InfoRight>
            <InfoDiv>
              <Introduction artwork={artwork} />
              <InfoButton
                artwork={artwork}
                type={MARKETTYPE.MEME}
                status={+status}
                canReview={canReview}
                updateNum={updateNum}
                setUpdateNum={setUpdateNum}
                isMyArtwork={+isMyArtwork === 1 ? true : false}
                tokenName={SUPPORTTYPE.BAKE}
              ></InfoButton>
            </InfoDiv>
            <InfoAddress artwork={artwork} type={NFTTYPE} />
            </InfoRight>
          </RowColumnInfo>
          <BidTrad>
            <BiddingList updateNum={updateNum} type={NFTTYPE} tokenId={artwork.tokenId} />
            <TradingList updateNum={updateNum} type={NFTTYPE} nftId={artwork.nftId} />
          </BidTrad>
          <TabRow margin="49px auto 36px" width="calc(100% - 40px)">
            <TextLabel style={{flex: 1}} height={37} color={theme.text1} size={22}>More Artworks</TextLabel>
            <TabRow>
              <SortPets
                margin="0 15px 0 0"
                curSelect={curTab}
                options={TabOptions}
                updateData={upTab}
              ></SortPets>
              <SortPets
                wd='110px'
                curSelect={curSelect}
                options={SortOptions}
                updateData={updateData}
              ></SortPets>
            </TabRow>
          </TabRow>
          {
            artworks.length ? (
              <>
                <ArtworksList>
                  {
                    artworks.map((d, index) => {
                      return (
                        index < LIMIT ?
                        <Artworks
                          key={d.tokenId}
                          artwork={d}
                          isMyArtwork={false}
                          bakeBalance={bakeBalance}
                          status={canReview ? +status : 1}
                          canReview={canReview}
                          history={history}
                          tokenName={SUPPORTTYPE.BAKE}
                        /> : ''
                      )
                    })
                  }
                  {
                    pageCount > 1 && (
                      <Paginator pageCount={pageCount} curPage={page} page={pageHandle}></Paginator>
                    )
                  }
                </ArtworksList>
              </>
            ) : !loadingFlag && <NoArtworks type={MARKETTYPE.MEME} status={+status} />
        }
      </RowColumn>
    </>
  )
}
